export type MarketState = 'pre' | 'open' | 'after' | 'closed';

export interface MarketStatus {
  state: MarketState;
  label: string;
  detail: string;
}

export function getMarketStatus(date = new Date()): MarketStatus {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const weekday = parts.find((part) => part.type === 'weekday')?.value ?? 'Mon';
  const hour = Number(parts.find((part) => part.type === 'hour')?.value ?? '0');
  const minute = Number(parts.find((part) => part.type === 'minute')?.value ?? '0');
  const minutes = hour * 60 + minute;
  const weekend = weekday === 'Sat' || weekday === 'Sun';

  if (weekend) {
    return { state: 'closed', label: 'Closed', detail: 'Weekend' };
  }
  if (minutes >= 4 * 60 && minutes < 9 * 60 + 30) {
    return { state: 'pre', label: 'Pre-market', detail: 'Opens 9:30 ET' };
  }
  if (minutes >= 9 * 60 + 30 && minutes < 16 * 60) {
    return { state: 'open', label: 'Open', detail: 'Closes 16:00 ET' };
  }
  if (minutes >= 16 * 60 && minutes < 20 * 60) {
    return { state: 'after', label: 'After hours', detail: 'Closed at 16:00 ET' };
  }
  return { state: 'closed', label: 'Closed', detail: 'Opens 9:30 ET' };
}
